import AtomSkeleton, {ATOM_SKELETON_VARIANTS} from '@s-ui/react-atom-skeleton'

const SKELETON_ANIMATION = 'pulse'

const skeleton = {
  ANIMATION: SKELETON_ANIMATION,
  HEIGHT: '239px',
  WIDTH: '530px'
}

export const CardAdSkeleton = () => {
  return (
    <AtomSkeleton
      variant={ATOM_SKELETON_VARIANTS.square}
      height={skeleton.HEIGHT}
      width={skeleton.WIDTH}
      animation={skeleton.ANIMATION}
    />
  )
}

CardAdSkeleton.displayName = 'CardAdSkeleton'
